export const calculatePercent = (value, total) => {
  const calculatedValue = Math.ceil((value / total) * 1000) / 10;
  if (isNaN(calculatedValue) || calculatedValue === Infinity) return 0;
  return roundDec(calculatedValue);
};

export const roundDec = (n) => {
  return Number(n.toFixed(1));
};
